import { Product } from "@transfr-inc/dashboard-components/constants";
import { getProduct } from "@transfr-inc/dashboard-components/utils";

export const SEC_IN_MINUTE = 60;
export const SEC_IN_HOUR = 60 * SEC_IN_MINUTE;
export const SEC_IN_DAY = 24 * SEC_IN_HOUR;

export const WORK_HOURS_PER_YEAR = 2080;

export const DEFAULT_FPS = 30;
export const MAX_FPS = 120;

export const TARGET_FPS = {
  1: 15,
  2: DEFAULT_FPS,
  3: 60,
};

export const ROLES = {
  instructor: 1,
  student: 2,
  admin: 3,
  multi_org_admin: 6,
  org_admin: 8,
};

export const ROLE_NAMES = {
  1: "Instructor",
  2: "Learner",
  3: "Admin",
  6: "Multi-Org Admin",
  8: "Org Admin",
};

export const CareerRating = {
  zero: 0,
  one: 1,
};

export const SESSION_VALUE_KEYS = { careerMatchesSort: "careerMatches.sort" };

export const NUM_INITIAL_BUDGETING_GAME_QUESTIONS = 1;

export const FEEDBACK_FORM_URL = {
  url: `https://transfr.qualtrics.com/jfe/form/SV_0k8McRqkP7cqzlk`,
  getUrl: function ({ orgCode, email }) {
    const url = new URL(this.url);
    const product = getProduct(Product.TRK);
    url.searchParams.append(
      "product",
      product.displayName?.replace(/[()]/g, ""),
    );

    if (orgCode) {
      url.searchParams.append("clientcode", orgCode);
    }
    if (email) {
      url.searchParams.append("clientemail", email);
    }
    return url.toString();
  },
};
